var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.getTaskDefinitions}},[_vm._v("Refresh")]),_c('DataTable',{attrs:{"rowKeys":['name'],"rows":_vm.taskDefinitions,"actions":_vm.readOnly
        ? [
            {
              name: 'taskDefinition',
              label: 'View',
              params: { name: 'taskType' }
            }
          ]
        : [
            {
              name: 'taskDefinition',
              label: 'View',
              params: { name: 'taskType' }
            },
            {
              name: 'taskDefinitionEdit',
              label: 'Edit',
              params: { name: 'taskType' }
            }
          ],"columns":[
      { name: 'name', type: 'text' },
      { name: 'createTime', type: 'date' },
      { name: 'updateTime', type: 'date' },
      { name: 'description', type: 'text' }
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }